module.exports = __webpack_public_path__ + "static/media/unionVisa.2fa98a6d.svg";